import React, {FC} from "react"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {H5} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"
import InjectIntl, {injectIntl} from "@irati/utils/lang"
import {EmptyContainer, IconWrapper, ExternalBorder} from "./styled"

interface Props extends InjectIntl {}

const EmptyCardsContainer: FC<Props> = ({formatMessage}) => {
  const theme = useTheme()

  return (
    <EmptyContainer>
      <ExternalBorder>
        <IconWrapper>
          <Icon icon={IconTypes.notificationBold} size={96} color={theme.colors.greys.white} />
        </IconWrapper>
      </ExternalBorder>
      {/* TODO - add phrase key for below message */}
      <H5 marginTop={3} bold>{formatMessage({id: "platform.notifications.empty"})}</H5>
    </EmptyContainer>
  )
}

export default injectIntl(EmptyCardsContainer)
